import { GET_STATES } from "../actions/types";

const states = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_STATES:
      return payload;
    default:
      return state;
  }
};

export default states;
